import { connect } from 'react-redux';
import * as organizationConstants from '../../constants/organizations';
import * as organizationSettingsSelectors from '../../selectors/organizationSettingsSelectors';
import Settings from '../../components/settings/Settings';

const mapStateToProps = state => {
    return {
        name: organizationSettingsSelectors.getName(state),
    };
};

const mapDispatchToProps = dispatch => ({
    onNameChange: reactEvent =>
        dispatch({
            type: organizationConstants.CHANGE_ORGANIZATION_SETTINGS_NAME,
            payload: reactEvent.nativeEvent.target.value,
        }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Settings);



// WEBPACK FOOTER //
// ./src/containers/organizationSettings/OrganizationBasicSettings.js